import React from 'react';
import classNames from 'classnames';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/TextLink';
import { handleLoginWithRedirect } from 'utils/login';
import { useTrolley } from 'contexts/Trolley';
import { urls } from 'constants/urls';
import { useMinSpend } from 'hooks/use-min-spend';
import { ShoppingSummary } from './ShoppingSummary';
import styles from './ShoppingSummaryContainer.module.scss';

const ShoppingSummaryContainer = ({ scrolled }: { scrolled?: boolean }) => {
  const { state: authState } = useAuthentication();
  const { state: trolleyState } = useTrolley();
  const { showMinSpend } = useMinSpend();

  // TODO - Move shouldRenderLoggedInVersion to a shared location to avoid repetition
  const shouldRenderLoggedInVersion =
    (authState.hasTokenSession && !authState.initialised) ||
    (authState.initialised && authState.isLoggedIn);

  const SignInOrTrolley = shouldRenderLoggedInVersion ? (
    <ShoppingSummary
      loadingStatus={trolleyState.loading}
      totalEstimatedCost={trolleyState.totalEstimatedCost}
      totalNumberOfItems={trolleyState.totalNumberOfItems}
      hasTrolleyError={!!trolleyState.error}
      testIdSuffix="mobile"
      scrolled={scrolled}
    />
  ) : (
    <TextLink
      data-testid="mobileHeaderSigninLink"
      href={urls.login}
      onClick={handleLoginWithRedirect}
      underline="never"
    >
      Sign in
    </TextLink>
  );

  return (
    <>
      <div className={styles.trolley} data-testid="shopping-summary-container-desktop">
        <ShoppingSummary
          hasTrolleyError={!!trolleyState.error}
          loadingStatus={trolleyState.loading && shouldRenderLoggedInVersion}
          totalEstimatedCost={trolleyState.totalEstimatedCost}
          totalNumberOfItems={trolleyState.totalNumberOfItems}
          scrolled={scrolled}
        />
      </div>
      <div
        className={classNames(styles.signInOrTrolley, {
          [styles.hasMinSpend]: showMinSpend,
        })}
        data-testid="shopping-summary-container-mobile"
      >
        {SignInOrTrolley}
      </div>
    </>
  );
};

export default ShoppingSummaryContainer;
